import { useAuth } from "../services/auth/CognitoAuthContext";
import { checkUserPermission } from "../services/util";

const UserPermission = ({ groups = [], children }) => {
  const { session } = useAuth();
  const isAllowed = checkUserPermission(session.authenticated, groups, session.userInfo);
  return isAllowed ? children : null;
};

export default UserPermission;
